import { TabBarPropertiesType } from "@website/ui/tab-bar/tab-bar.types";
import { useRef } from "react";
export const useTabBar = (properties: TabBarPropertiesType) => {
  const {
    orientation
  } = properties;
  const buttonsContainerReference = useRef<HTMLDivElement>(null);
  const onNextScrollClick = () => {
    if (buttonsContainerReference.current) {
      if (orientation === "vertical") {
        buttonsContainerReference.current?.scrollTo(0, Number(buttonsContainerReference.current?.scrollTop) + 100);
      } else {
        buttonsContainerReference.current?.scrollTo(Number(buttonsContainerReference.current?.scrollLeft) + 100, 0);
      }
    }
  };
  const onPreviousScrollClick = () => {
    if (buttonsContainerReference.current) {
      if (orientation === "vertical") {
        buttonsContainerReference.current?.scrollTo(0, Number(buttonsContainerReference.current?.scrollTop) - 100);
      } else {
        buttonsContainerReference.current?.scrollTo(Number(buttonsContainerReference.current?.scrollLeft) - 100, 0);
      }
    }
  };
  const scrollButtonShow = orientation === "vertical" ? Number(buttonsContainerReference.current?.scrollHeight) >= Number(buttonsContainerReference.current?.offsetHeight) + 100 : Number(buttonsContainerReference.current?.scrollWidth) >= Number(buttonsContainerReference.current?.offsetWidth) + 100;
  return {
    buttonsContainerProps: {
      ref: buttonsContainerReference
    },
    nextScrollProps: {
      onClick: onNextScrollClick,
      hidden: !scrollButtonShow
    },
    previousScrollProps: {
      onClick: onPreviousScrollClick,
      hidden: !scrollButtonShow
    }
  };
};